import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme, useAppStyles } from '../theme';

export const Card = ({ children, style={}, onClick }) => {
  const C = useTheme();
  const styles = useAppStyles();
  return (
    <div onClick={onClick} style={{
      background: C.card,
      borderRadius: 16,
      padding: 16,
      boxShadow: C.shadow,
      border: `1px solid ${C.border}`,
      ...style
    }}>
      {children}
    </div>
  );
};

export const BackBtn = () => {
  const nav = useNavigate();
  const C = useTheme();
  return (
    <button onClick={()=>nav(-1)} style={{
      background: C.input,
      border: `1px solid ${C.border}`,
      borderRadius: 12,
      width: 40, height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontSize: 18,
      color: C.text,
    }}>←</button>
  );
};

export const LoadingSkeleton = ({ height=16, width='100%', borderRadius=8 }) => {
  const C = useTheme();
  return (
    <div style={{
      height, width, borderRadius,
      background: `linear-gradient(90deg, ${C.border} 25%, ${C.input} 50%, ${C.border} 75%)`,
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s infinite',
    }}/>
  );
};

export function useStatusBar(color) {
  React.useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', color);
    return () => {
      if (meta) meta.setAttribute('content', '#1a3cc8');
    };
  }, [color]);
}

